export default __webpack_public_path__ + "static/media/no-races.c94974c0.png";